import React, { useEffect } from 'react';

import {
  IMonitorNotificationProviderBaseClass,
  IMonitorNotificationProviderBaseClassProps,
} from '~/src/dash/components/monitor/monitor_notifications/notifier';
import { IStore } from '~/src/dash/reducers/store';
import { IUserStateProps } from '~/src/dash/types/props';
import { decorateV2 } from '~/src/dash/utils/decorator';

export interface IMonitorNotifierOpsgenieDataForHistory {
  datadog_response: string;
}

interface IProps extends IMonitorNotificationProviderBaseClassProps, IUserStateProps {}

const _MonitorNotifierOpsgenieComponent: React.FC<IProps> = (props: IProps) => {
  useEffect(() => {
    props.onUpdateData({});
  }, []);

  return (
    <>
      <p>Only used for super admin. The datadog token is already hardcoded on the backend</p>
    </>
  );
};

export const MonitorNotifierOpsgenieComponent = decorateV2<
  typeof _MonitorNotifierOpsgenieComponent
>(
  {
    redux: (state: IStore) => {
      return {
        user: state.user,
        session: state.session,
      };
    },
    router: true,
  },
  _MonitorNotifierOpsgenieComponent,
);

export class MonitorNotifierOpsgenie implements IMonitorNotificationProviderBaseClass {
  returnData: (data: any) => void = undefined as any;
  // @ts-ignore
  Render = (notifier: any) => (
    <MonitorNotifierOpsgenieComponent
      // @ts-ignore
      notifier={notifier}
      onUpdateData={(data: any) => {
        if (this.returnData !== undefined) {
          this.returnData(data);
        }
      }}
    />
  );

  SetReturnData(cb: (data: any) => void) {
    this.returnData = cb;
  }

  Validate(): string {
    return '';
  }

  IsSuperAdminOnly(): boolean {
    return true;
  }
}
